import * as React from "react"
import type { SVGProps } from "react"
const SvgPrint = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M8 21.57q-.82 0-1.41-.59A2 2 0 0 1 6 19.57v-2H4q-.82 0-1.41-.59A2 2 0 0 1 2 15.57v-4q0-1.27.88-2.14c.88-.87 1.29-.86 2.12-.86h14q1.27 0 2.14.86.86.87.86 2.14v4q0 .82-.59 1.41a2 2 0 0 1-1.41.59h-2v2q0 .82-.59 1.41a2 2 0 0 1-1.41.59zm-4-6h2q0-.82.59-1.41A2 2 0 0 1 8 13.57h8q.83 0 1.41.59.6.58.59 1.41h2v-4a1 1 0 0 0-.29-.71 1 1 0 0 0-.71-.29H5a1 1 0 0 0-.71.29 1 1 0 0 0-.29.71zm12-7v-3H8v3H6v-3q0-.82.59-1.41A2 2 0 0 1 8 3.57h8q.83 0 1.41.59.6.59.59 1.41v3zm2 4.5q.42 0 .71-.29a1 1 0 0 0 .29-.71 1 1 0 0 0-.29-.71 1 1 0 0 0-.71-.29 1 1 0 0 0-.71.29 1 1 0 0 0-.29.71q0 .42.29.71.29.3.71.29m-2 6.5v-4H8v4z" />
  </svg>
)
export default SvgPrint
